import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { CustomerMasterReportContent } from './customer-master-report-page-components/CustomerMasterReportContent';

const CUSTOMER_MASTER_SUGGESTIONS = [
  'Give me a customer master overview',
  'Top 10 customers by MRR',
  "What's our revenue concentration?",
  'Show me the renewal pipeline',
  'Break down customers by subsidiary',
];

const CustomerMasterReportLayout: React.FC = () => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <Box
      sx={{
        transition: (theme) =>
          theme.transitions.create('margin-right', {
            easing: isOpen ? theme.transitions.easing.easeOut : theme.transitions.easing.sharp,
            duration: isOpen
              ? theme.transitions.duration.enteringScreen
              : theme.transitions.duration.leavingScreen,
          }),
        marginRight: isOpen ? `${drawerWidth}px` : 0,
      }}
    >
      <VyLayout>
        <CustomerMasterReportContent />
      </VyLayout>
    </Box>
  );
};

const CustomerMasterReportPage: React.FC = () => {
  const { setSuggestions } = useAiCopilot();

  useEffect(() => {
    setSuggestions(CUSTOMER_MASTER_SUGGESTIONS);
    return () => setSuggestions(undefined);
  }, [setSuggestions]);

  return (
    <>
      <Helmet>
        <title>Report</title>
      </Helmet>
      <CustomerMasterReportLayout />
    </>
  );
};

const CustomerMasterReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(CustomerMasterReportPage),
);

export { CustomerMasterReportPageWithSuspenseBoundary as CustomerMasterReportPage };
